
import { LoadOptions } from 'devextreme/data';
import CustomStore, { Options } from 'devextreme/data/custom_store';
import { ApolloAnswer, IDocDefProps } from 'types/otkTypes';

export interface IDocProps extends IDocDefProps {
  date: string; // "2024-11-01T16:11:47",
  number_doc?: string; // "ТЕХ00000159",
  organization?: string; //"206b71b2-ffb1-11e8-80fd-00155dcccf0a",
  department?: string;//"df42448b-b393-11e9-8107-00155dcccf0a",
  note?: string; // "Довіреність на Сидоряк М.І.",
  posted?: boolean;
}

export interface ICatProps extends IDocDefProps {
  id?: string
}

export class CustomStoreExt<TItem=any, TKey=any> extends CustomStore<TItem, TKey> {
  private _userData?: any;

  userOptions: {
      [key: string]: any
    };

  constructor(options?:Options<TItem, TKey>) {
    super(options);
    this.userOptions = {};
  }

  set userData(userData:any) {
    this._userData = userData;
  }

  get userData():any {
    return this._userData;
  }

  filter(value?: object) {
    this.userOptions.hardFilter = value;
  }


  async loadExt(options?:LoadOptions<TItem>): Promise<ApolloAnswer<TItem>> {
    const result = options ? (await super.load(options)) : await super.load();
    // If result is already ApolloAnswer, return as is; otherwise, wrap in ApolloAnswer
    if (result && typeof result === 'object' && 'data' in result) {
      return result as ApolloAnswer<TItem>;
    }
    return {
      data: result,
      totalCount: Array.isArray(result) ? result.length : undefined
    };
  }

  async loadData(options?:LoadOptions<TItem>): Promise<TItem[]> {
    return (await this.loadExt(options)).data;
  }

}
